import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from './../../services/events.service';
import { RestService } from './../../services/rest.service';
import { Component, OnInit } from '@angular/core';
import { BackButtonService } from 'src/app/services/back-button.service';
import { SnackbarService } from '@bcl/design-system';
import { ViewWillEnter } from '@ionic/angular';

@Component({
  selector: 'app-gas',
  templateUrl: './gas.component.html',
  styleUrls: ['./gas.component.scss'],
})
export class GasComponent implements OnInit, ViewWillEnter {
  orderId: number;
  gasDefinitions: any[] = [];
  gasMeasurements: any[] = [];
  dataChanges: any[] = [];

  constructor(
    private rest: RestService,
    private router: Router,
    private route: ActivatedRoute,
    private backButtonService: BackButtonService,
    private snackbarService: SnackbarService
  ) {
    this.orderId = +this.route.snapshot.paramMap.get('id');
    this.rest.getGasDefinitions(this.orderId).then((gasDefs: any) => {
      this.gasDefinitions = gasDefs;
      this.gasDefinitions.forEach((obj) => {
        this.rest
          .getGasMeasurements(this.orderId, obj.GasStructure)
          .then((gasM: any) => {
            this.gasMeasurements[obj.GasStructure] = gasM;
          });
      });
    });
  }

  ngOnInit() {}

  ionViewWillEnter() {
    this.setupBackButton();
  }

  goBack() {
    this.router.navigate(['details', this.orderId]);
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad GasPage');
  }

  formataNumero(e: any, separador: string = '.', decimais: number = 2) {
    const a: any = e.value.split('');
    let ns = '';
    a.forEach((c: any) => {
      if (!isNaN(c)) {
        ns = ns + c;
      }
    });
    ns = parseInt(ns, 10).toString();
    if (ns.length < decimais + 1) {
      ns = '0'.repeat(decimais + 1) + ns;
      ns = ns.slice((decimais + 1) * -1);
    }
    const ans = ns.split('');
    let r = '';
    for (let i = 0; i < ans.length; i++) {
      if (i === ans.length - decimais) {
        r = r + separador + ans[i];
      } else {
        r = r + ans[i];
      }
    }
    e.value = r;
  }

  save() {
    console.log(JSON.stringify(this.dataChanges));
    const json = {
      username: this.rest.username,
      measurements: this.dataChanges,
    };
    this.rest.saveGasMeasurements(this.orderId, json);
    this.snackbarService.open('green', 'GAS_PAGE.MESSAGES.GAS_SAVED');
    this.router.navigate(['details', this.orderId]);
  }

  //valChange(value: string, measureID: number): void{
  valChange(event: any, measureID: number): void {
    const element = event.target as HTMLInputElement;
    const value = element.value;
    // this.dataChanges.push( {measureID,value} );
    this.pushToArray(this.dataChanges, { measureID, value });
    // console.log("value chage : " + measureID + " : " + value);
  }

  pushToArray(arr, obj) {
    const index = arr.findIndex((e) => e.measureID === obj.measureID);

    if (index === -1) {
      arr.push(obj);
    } else {
      arr[index] = obj;
    }
  }
  private setupBackButton() {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }
}
